import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    multi_image: [
      'shop now - image1',
      'shop now - image2',
      'shop now - image3'
    ],
    multi_button: [
      'shop now - button1',
      'shop now - button2',
      'shop now - button3'
    ],
    multi_sub_button: ['close - button1', 'close - button2', 'close - button3']
  }
};

const RadiusModalSlideTracking: FC = () => {
  const currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  const tracking = useSelector((state: RootState) => state.trackings.tracking);

  const style = `
    a {
      color: #000000;
      text-decoration: none;
      cursor: pointer;
    }

    .root_tracking {
        width: 100%;
        height: 100%;

        position: relative;
        overflow: hidden;
        background: none;

        .modal_wrapper {
            width: 100%;

            display: flex;
            flex-direction: column;
            gap: 1rem;
        
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        
            overflow: hidden;
            background-color: transparent;
        }

        .contents_wrapper {
            padding: 0 10%;
        }
        .contents_wrapper .title {
            width: 100%;
            height: 2.5rem;
        }

        .slick_wrapper,
        .slick_wrapper .slick-slider,
        .slick_wrapper .slick-list {
            width: 100%;
            min-height: 12.5rem;
        }
        
        .slick_wrapper .slick-track div,
        .slick_wrapper .slick-track img {
            width: 15rem;
            min-height: 10rem;
            outline: none;
        }
        .slick_wrapper .slick-track img {
            object-flt: cover;
        }
        .slick_wrapper .slick-track {
            display: flex;
            margin-left: 10%;
        }
        .slick_wrapper .slick-track img {
         object-fit: cover;
        }

        .slick_wrapper .slick-slide {
            margin-right: 1rem;
        }
        .slick_wrapper .slick-list {
            margin-right: -1rem;
        }

        .slick_wrapper .countdown {
            width: 100%;
            max-height: 1.5rem;
            margin-top: 0.5rem;

            display: flex;
            justify-content: end;
            align-items: center;
        }
        .countdown_title {
            max-height: 1.5rem;
            margin-right: 0.5rem;
        }

        .bottom_wrapper {
            width: 100%;
            height: 2rem;
        }

        .close_btn button {
            width: 100%;
            margin-top: 2rem;
            border: 0;
            background: transparent;
        }

        .tracking_center {
            display: flex;
            align-items: center;
            justify-content: end;
        }
    }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_tracking">
        <div className="modal_wrapper">
          <div className="contents_wrapper">
            <div className="title" />
          </div>
          <div className="slick_wrapper tracking_center">
            <EditTracking
              value={tracking?.multi_image?.[currentIndex]}
              type="multi_image"
            />
          </div>
          <div>
            <div className="bottom_wrapper tracking_center">
              <EditTracking
                value={tracking?.multi_button?.[currentIndex]}
                type="multi_button"
              />
            </div>
            <div className="close_btn">
              <button className="tracking_center">
                <EditTracking
                  value={tracking?.multi_sub_button?.[currentIndex]}
                  type="multi_sub_button"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RadiusModalSlideTracking;
